import { IRootState } from '../../../store'
import { IFluidsState } from '../store/fluids.types'

export const getFluidsSelector = (state: IRootState): IFluidsState => state.fluids
